import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

// Finding 5 — `getCurationRunStats` lives only in curation.service.ts (the one implementation
// that handles 422 `LEDGER_TOO_LARGE`); run-detail.service.ts re-exports it for its other callers.
import { getCurationRunStats } from '../services/curation.service';
import { getCurationRunOutcomes } from '../services/run-detail.service';

/** The run's curation counts + funnel (CURATION gate). Only for flows with a CURATION stage. */
export function useRunCurationStats(runId: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.catalogService.curationStats(runId),
    queryFn: () => getCurationRunStats(runId),
    enabled: enabled && !!runId,
  });
}

/**
 * What the run's curation did, by outcome. 404s for a flow without CURATION,
 * so callers gate it on the flow's stages.
 */
export function useRunCurationOutcomes(runId: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.catalogService.curationOutcomes(runId),
    queryFn: () => getCurationRunOutcomes(runId),
    enabled: enabled && !!runId,
  });
}
